import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isEmpty } from 'lodash';
import { ValuesExchangeProvider, SCRIPT_STATUS_MESSAGE } from '@nrwl/common-lib';
import { SaveScriptService } from './save-script.service';

@Component({
  selector: 'nrwl-save-script-dialog',
  templateUrl: './save-script-dialog.component.html',
  styleUrls: ['./save-script-dialog.component.scss']
})
export class SaveScriptDialogComponent implements OnInit {
  scriptName: string;
  errorMessage: string;
  saveAsNewScript = false;
  showPrecheckOperation = false;
  showConfirmationPopup = false;
  showScriptSavingPopup = false;
  preCheckPassed = false;
  isLoading = false;
  scriptSaveFailed = false;
  scriptStatusMessage = SCRIPT_STATUS_MESSAGE.STARTING;
  constructor(
    // eslint-disable-next-line
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SaveScriptDialogComponent>,
    private readonly exchange: ValuesExchangeProvider,
    private saveScriptService: SaveScriptService
  ) {}

  ngOnInit(): void {
    this.showConfirmationPopup = this.data.showConfirmationPopup;
    this.showPrecheckOperation = this.data.precheckOperation;
    this.preCheckPassed = this.data.preCheckedPassed;
    this.scriptName = this.data.scriptName;
  }

  onSaveClicked(): void {
    if (this.saveAsNewScript) {
      this.showScriptSavingPopup = true;
      this.showConfirmationPopup = false;
      this.showPrecheckOperation = false;
      this.isLoading = true;
      this.exchange.notifyListeners('create_script', false);
      this.saveScriptService
        .saveScript(this.data.id, this.data.editorValue, this.scriptName)
        .subscribe(
          res => {
            this.isLoading = false;
            this.scriptSaveFailed = false;
            this.scriptStatusMessage = SCRIPT_STATUS_MESSAGE.SUCCESSFULL;
            this.exchange.notifyListeners('create_script', true);
          },
          () => {
            this.isLoading = false;
            this.scriptSaveFailed = true;
            this.scriptStatusMessage = SCRIPT_STATUS_MESSAGE.ERROR;
          }
        );
    } else {
      this.showConfirmationPopup = false;
      this.showPrecheckOperation = true;
    }
  }
  onSaveMyScriptClicked(): void {
    this.saveAsNewScript = true;
    this.onSaveClicked();
  }

  savePrecheckScript(): void {
    this.isLoading = true;
    this.saveScriptService
      .saveScript(this.data.id, this.data.editorValue, this.scriptName)
      .subscribe(
        () => {
          this.isLoading = false;
          this.dialogRef.close({
            precheckOperation: true,
            scriptName: this.scriptName,
            dialogClose: true
          });
        },
        () => {
          this.isLoading = false;
          this.showScriptSavingPopup = true;
          this.showConfirmationPopup = false;
          this.showPrecheckOperation = false;
          this.scriptSaveFailed = true;
          this.scriptStatusMessage = SCRIPT_STATUS_MESSAGE.ERROR;
        }
      );
  }

  openSaveScript(): void {
    this.scriptName = '';
    this.saveAsNewScript = true;
    this.showConfirmationPopup = false;
    this.showPrecheckOperation = false;
  }

  saveAs(): void {
    this.data.editMode = false;
  }

  isValidScriptName(): boolean {
    if (this.data.editMode) return false;
    return this.data.closeIconClicked ? false : isEmpty(this.scriptName) ? true : false;
  }

  isNameAlreadyExist(): boolean {
    return this.data.allScriptNames.some(scriptName => scriptName.trim() === this.scriptName);
  }

  disableSaveButton(): boolean {
    if (isEmpty(this.scriptName)) {
      return true;
    }
    return this.isNameAlreadyExist();
  }

  closeDialog(closeStatus: boolean): void {
    this.dialogRef.close({ scriptName: this.scriptName, dialogClose: closeStatus });
  }
}
